import { useEffect, useMemo } from 'react';
import { Box, Button, Typography, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'dva';
import { useDispatch } from 'umi';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import DataTableNativeML from '@/components/DataTableNativeML';
import { SelectFieldCom, TextFieldCom } from '@/components/FormType';

export default (props) => {
  const dispatch = useDispatch();
  const {
    columnKey = 'id',
    dialogStatus,
    onCloseDialog,
    title,
    handleSubmit,
    onSubmitSuccess,
    chooseIds,
    control,
    getValues,
    setValue,
    watch,
    reset,
    columns,
    changePage,
    onHandleClickSearchStoresResetCallback,
  } = props;
  let {
    storeName,
    storeCode,
    storeStatus,
    storeType,
    storesPageNum,
    storesPageSize,
    storesList,
    storesTotal,
  } = useSelector((state) => state.couponsSetting);
  const { storeTypeList } = useSelector((state) => state.storeAnalysis);
  useEffect(() => {
    if (dialogStatus) {
      reset({ storeCode, storeName, storeStatus, storeType });
    }
  }, [dialogStatus]);
  //获取门店类型
  useEffect(() => {
    dispatch({
      type: 'storeAnalysis/getStoreType',
      payload: {
        values: {},
      },
    });
  }, []);

  const initStoreTypeList = useMemo(() => {
    return storeTypeList?.map((item) => ({
      name: item,
      value: item,
    }));
  }, [storeTypeList]);

  const onHandleClickSearchReset = () => {
    reset({
      storeCode: null,
      storeName: null,
      storeStatus: null,
      storeType: null,
    });
    dispatch({
      type: 'couponsSetting/searchStores',
      payload: {
        value: { ...data, pageNum: 1, pageSize: storesPageSize },
      },
    });
    onHandleClickSearchStoresResetCallback &&
      onHandleClickSearchStoresResetCallback();
  };
  const labelCom = (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography
            variant="body1"
            className="coupon-dialog-title-init-style"
          >
            {title}
          </Typography>
        </Box>
        {onCloseDialog ? (
          <IconButton aria-label="close" onClick={() => onCloseDialog()}>
            <CloseIcon className="coupon-dialog-close-icon-init-style" />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );
  const storesContent = () => {
    return (
      <div style={{ width: '900px' }}>
        <form onSubmit={handleSubmit(onSubmitSuccess)}>
          <Box display="flex" justifyContent="flex-end" gap="12px">
            <div style={{ flex: 1 }}>
              <SelectFieldCom
                label="门店状态"
                name="storeStatus"
                // placeholder="请选择分组"
                control={control}
                getValues={getValues}
                setValue={setValue}
                typeList={[
                  { name: ' 营业中', value: 1 },
                  { name: ' 闭店中', value: 2 },
                ]}
                watchAllFields={watch()}
              />
            </div>
            <div style={{ flex: 1 }}>
              <SelectFieldCom
                label="门店类型"
                name="storeType"
                control={control}
                getValues={getValues}
                setValue={setValue}
                typeList={initStoreTypeList || []}
                watchAllFields={watch()}
              />
            </div>
            <div style={{ flex: 1 }}>
              <TextFieldCom
                label="门店名称"
                placeholder="请输入门店名称"
                name="storeName"
                control={control}
                getValues={getValues}
                setValue={setValue}
              />
            </div>
            <div style={{ flex: 1 }}>
              <TextFieldCom
                label="门店code"
                placeholder="请输入门店code"
                name="storeCode"
                control={control}
                getValues={getValues}
                setValue={setValue}
              />
            </div>
            <div style={{ display: 'flex', gap: '24px', flex: 1 }}>
              <Button onClick={onHandleClickSearchReset} variant="contained">
                重置
              </Button>
              <Button
                type="submit"
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                搜索
              </Button>
            </div>
          </Box>
          <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <Box
              style={{
                height: '640px',
                overflowY: 'scroll',
                padding: '0 32px 32px',
              }}
            >
              <DataTableNativeML
                paging={true}
                columns={columns}
                data={storesList || []}
                columnKey={columnKey}
                total={Math.abs(storesTotal)}
                devicesMinWidth="auto"
                chooseIds={chooseIds}
                page={{
                  pageSize: Math.abs(storesPageSize),
                  pageNum: Math.abs(storesPageNum),
                }}
                np={true}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                changePage={changePage}
              />
            </Box>
          </div>
        </form>
        <div
          style={{
            display: 'flex',
            gap: '24px',
            justifyContent: 'flex-end',
          }}
        >
          <Button onClick={() => onCloseDialog()} variant="contained">
            取消
          </Button>
          <Button onClick={() => onCloseDialog(1)} variant="contained">
            确定
          </Button>
        </div>
      </div>
    );
  };
  return (
    <DialogDataML
      open={dialogStatus}
      title={labelCom}
      content={storesContent()}
      onClose={onCloseDialog}
      button={{ isShow: false }}
    />
  );
};
